import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import {selectDate, createVideo, showModalFlag, showDetailFlag} from '../../actions';

import {Api,Time, Regex, Config} from '../../util';
import Card from '../../components/card';
import {Video, Detail} from '../../components/modal';

let ONAIR_TIMER;

class CardListContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      showModal: false,
      showDetail: false,
      modalInfo: {},
      currentOnAirCard: {
        index: -1,
        card: {}
      }
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);

    this.hadnleOnDetailClick = this.hadnleOnDetailClick.bind(this);
    this.handleDetailClose = this.handleDetailClose.bind(this);
  }
  componentDidMount(){
    if(this.props.selectedDate === Time.getToday()){
      this.setCurrentAirCard()
        .then(() => {
          ONAIR_TIMER = setInterval(() => {
            this.checkOnAirCard()
          }, 1 * 1000);
        })
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.selectedDate === Time.getToday()){
      this.setCurrentAirCard()
        .then(() => {
          ONAIR_TIMER = setInterval(() => {
            this.checkOnAirCard()
          }, 1 * 1000);
        })
    }
  }
  componentWillUnmount(){
    clearInterval(ONAIR_TIMER);
    ONAIR_TIMER = undefined;
  }
  
  handleContextMenuClick(options){
    const {data} = options;
    const videoNum = options.data.toLowerCase();
    const videoObj = {};
    videoObj[videoNum] = options;
    this.props.createVideo(videoObj);
   
  }
  async handleOnClick(info) {
    if(info.active){
      await this.setState({
        showModal: true,
        modalInfo: info
      });
      await this.props.showModalFlag(this.state.showModal);
    }

  }

  async handleModalClose(){
    await this.setState({showModal: false});
    await this.props.showModalFlag(this.state.showModal);
  }

  async hadnleOnDetailClick(detailInfo){
    await this.setState({
      showDetail: true,
    });
    await this.props.showDetailFlag(this.state.showDetail, detailInfo);
  }
  
  async handleDetailClose(){
    await this.setState({showDetail: false});
    await this.props.showDetailFlag(this.state.showDetail);
  }

  setCurrentAirCard(){
    
    return new Promise(resolve => {
      const {cardList} = this.props;
      let onAirCard = {};
      cardList.forEach((card, index) => {
        // index = 0 에 대한 초기화
        if(index === 0){
          onAirCard.index = -1;
          onAirCard.card = card;
        }
        //현재 방송중인지 아닌지 비교한다.
        if(Time.isOnAir(card.start, card.stop)){
          onAirCard.index = index;
          onAirCard.card = card;
          return;
        }
      })
      this.setState({
        currentOnAirCard: onAirCard
      }, () => {
        resolve();
      });
    });
  
  }

  
  checkOnAirCard() {
    const {cardList} = this.props;
    const {card, index} = this.state.currentOnAirCard;
    if(card){
      if(!Time.isOnAir(card.start, card.stop)){
        if(index + 1 < cardList.length){
          setTimeout(async () => {
            try{
              const epgUrl = (await Api.GetVodInfo({
                ch: [{ chName: cardList[index+1].chname, start: cardList[index+1].start }]
              })).files.ch[0];
              this.setState({
                currentOnAirCard: {
                  card: cardList[index+1],
                  index: index+1,
                  url: epgUrl.url,
                  img: epgUrl.img,
                  bgColor: epgUrl.bgColor
                }
              })
            }catch(e){
              console.log(e);
            }
          }, 1000 * 100); // 100초 뒤에 활성화
        }
        // 마지막 index면 아무 일도 안한다.
      }
    }
  }
  render() {
    const {
      cardList,
      activeChannelListIndex,
      channelIndex,
      selectedDate
    } = this.props;
    const {
      showModal,
      modalInfo,
      currentOnAirCard,

      showDetail
    } = this.state;

    const cardListClasses = 'card-list ' + (activeChannelListIndex === channelIndex ? 'active' : '');
    
    
    return (
      <div className={cardListClasses}>
        {cardList.map((card, index) => {
          // FILE 타입과 card 값을 맞춘다.
          card.airDate = moment(card.start, 'YYYYMMDDHHmmss').format('YYYY-MM-DD');

          if(selectedDate === Time.getToday()
          && currentOnAirCard.index === index){
            card.active = Config.liveImgMode ? false : true;
            card.url = currentOnAirCard.url || card.url;
            card.img = currentOnAirCard.img || card.img;
            card.bgColor = currentOnAirCard.bgColor || card.bgColor;
          }else if(selectedDate === Time.getToday()
          && currentOnAirCard.index === index + 1){
            card.active = true;
            card.url = currentOnAirCard.url || card.url;
            card.img = currentOnAirCard.img || card.img;
            card.bgColor = currentOnAirCard.bgColor || card.bgColor;
          }
          // card.descStr = `${card.category && card.category}
          //             ${card.director && card.director}
          //             ${card.price && Regex.getPriceComma(card.price)}`;
          return <Card {...card} key={`${card.epgid}_${card.start}`}
                onContextMenuClick = {this.handleContextMenuClick}
                onDetailClick = {this.hadnleOnDetailClick}
                onClick={this.handleOnClick}
                  />
        })}
        {showModal ? <Video 
          handleModalClose={this.handleModalClose}
          modalInfo={modalInfo}
        /> : null}
        {showDetail && <Detail 
          handleDetailClose={this.handleDetailClose}
        />}
      </div>
    );
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    createVideo: (videoItem) => dispatch(createVideo(videoItem)),
    showModalFlag: (modalFlag) => dispatch(showModalFlag(modalFlag)),
    showDetailFlag: (detailFlag, detailInfo) => dispatch(showDetailFlag(detailFlag, detailInfo))
  }
};

const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu,
    videoItem: state.videoItem,
    chIndex: state.chIndex,
    activeChannelListIndex: state.activeChannelListIndex
  }
};

CardListContainer = connect(mapStateToProps,mapDispatcherToProps)(CardListContainer);

export default CardListContainer;


// WEBPACK FOOTER //
// ./src/containers/schedule/CardListContainer.js